import { FetchGlobalCompanyTabsSortTypes } from './globalCompanyTabsTypes';

export const INITIAL_GLOBAL_COMPANY_TABS_FILTERS = {};

export const INITIAL_GLOBAL_COMPANY_TABS_LIMIT = 50;

export const INITIAL_GLOBAL_COMPANY_TABS_PAGE = 1;

export const INITIAL_GLOBAL_COMPANY_TABS_SORT = [
  FetchGlobalCompanyTabsSortTypes.POSITION_ASC
];

// Next.js pathnames of the global company tab pages, i.e. the routes where
// the currently opened tab is defined by the tabNanoId route param
export const GLOBAL_COMPANY_TAB_ROUTE_PATHNAMES = [
  '/company/tabs/[tabNanoId]',
  '/companies/[slug]/tabs/[tabNanoId]'
];
